module.exports = __webpack_public_path__ + "img/104.6d75cb78.png";